import { createStyles, Header, Group , ThemeIcon, ActionIcon, Container, CopyButton, rem , Text , Avatar , Image , Center , Divider , Title , TypographyStylesProvider , UnstyledButton} from '@mantine/core';
import { IconBrandTwitter, IconMapPin , IconPhone , IconBrandInstagram , IconBrandLinkedin , IconBrandYoutube , IconBrandItch } from '@tabler/icons-react';
import { FooterSimple } from '../Components/Footer';
import {useNavigate , useLocation} from 'react-router-dom'
import {useEffect} from 'react';
import { TopImages } from '../Components/SlideImage';

const useStyles = createStyles((theme) => ({
    inner: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: rem(56),
  
      [theme.fn.smallerThan('sm')]: {
        justifyContent: 'flex-start',
      },
    },
  
    links: {
      width: rem(260),
  
      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },
  
    social: {
      width: rem(260),
  
      [theme.fn.smallerThan('sm')]: {
        width: 'auto',
        marginLeft: 'auto',
      },
    },
  }));
  
  const listData = {
    "footerLink": [
      {
        "link": "#",
        "label": "Copyright @ 2023"
      },
      {
        "link": "/privacy_policy",
        "label": "Privacy Policy"
      },
      {
        "link": "/terms_and_conditions",
        "label": "Terms and Condition"
      }
    ]
  }

function ProductPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const pData = location.state.article
    const { classes, cx } = useStyles();
    useEffect(() => {
      document.getElementById('header')?.scrollIntoView({behavior : 'auto'})
    }, [])
    
    return (
        <div>
            <Header height={56} mb={20} id='header'>
                <Container className={classes.inner}>
                <Group className={classes.links} spacing={5}>
                </Group>
                <Text
                    variant="gradient"
                    gradient={{ from: 'indigo', to: 'cyan', deg: 45 }}
                    sx={{ fontFamily: 'Greycliff CF, sans-serif' }}
                    ta="center"
                    fz="3.5vw"
                    fw={700}
                    onClick={()=>{navigate('/')}}
                    >
                Freak-Bros
                </Text>
                <Group spacing={0} className={classes.social} position="right" noWrap>
                <ActionIcon size="lg">
                    <IconBrandTwitter size="1.1rem" stroke={1.5} />
                </ActionIcon>
                <ActionIcon size="lg">
                    <IconBrandYoutube size="1.1rem" stroke={1.5} />
                </ActionIcon>
                <ActionIcon size="lg">
                    <IconBrandInstagram size="1.1rem" stroke={1.5} />
                </ActionIcon>
                <ActionIcon size="lg">
                    <IconBrandItch size="1.1rem" stroke={1.5} />
                </ActionIcon>
                <ActionIcon size="lg">
                    <IconBrandLinkedin size="1.1rem" stroke={1.5} />
                </ActionIcon>
                </Group>
                </Container>
            </Header>
            {/* bodyArea */}
            <Container size='md'>
            <TypographyStylesProvider>
                <div dangerouslySetInnerHTML={{ __html: 
                `<H1>${pData.title}</H1>`
                }} />
                <Container size='sm' style={{paddingTop: 12 , paddingBottom: 12}}>
                  <TopImages {...pData}/>
                </Container>
                <div dangerouslySetInnerHTML={{ __html: 
                `<p>${pData.intro}</p>`
                }} />
                <div dangerouslySetInnerHTML={{ __html: 
                `<p>${pData.description}</p>`
                }} />
            </TypographyStylesProvider>
            </Container>
            <FooterSimple links={listData.footerLink}/>
        </div>
  );
}

export default ProductPage;
